
import React, { useState } from "react";
import axios from "axios";
import { getToken, getUser } from "../../utils/auth";
import { useTranslation } from "react-i18next";
import CONFIG from "../../config";

const AdminProfile = () => {
    const { t } = useTranslation();
    const [form, setForm] = useState({ password: "", confirmPassword: "", email: getUser()?.email || "" });
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const isArabic = localStorage.getItem("i18nextLng") === "ar";

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (form.password && form.password !== form.confirmPassword) {
            setMessage(t('admin.admin_profile.password_mismatch', "Passwords do not match"));
            setStatus("error");
            return;
        }

        try {
            const token = getToken();
            const user = getUser();

            const payload = {
                email: form.email,
            };
            if (form.password) payload.password = form.password;

            await axios.put(`${CONFIG.API_URL}/api/admin/users/${user.id}`, payload, { headers: { Authorization: `Bearer ${token}` } });

            setMessage(t('admin.admin_profile.update_success', "Profile updated successfully. Please re-login if you changed your credentials."));
            setStatus("success");
        } catch (err) {
            console.error(err);
            setMessage(err.response?.data?.message || t('admin.admin_profile.update_failed', "Update failed"));
            setStatus("error");
        }
    };

    return (
        <div className="max-w-4xl mx-auto my-12 p-8 bg-white rounded-[40px] shadow-2xl border border-gray-100 mt-24">
            <div className="flex items-center justify-between mb-12">
                <h2 className="text-4xl font-black text-gray-900 tracking-tight">{t('admin.admin_profile.title', 'Admin Profile')}</h2>
                <button
                    onClick={() => window.history.back()}
                    className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all"
                >
                    <span className={`inline-block transition-transform group-hover:-translate-x-1 ${isArabic ? "rotate-180 group-hover:translate-x-1" : ""}`}>←</span>
                    {t('admin.common.back', 'Back')}
                </button>
            </div>

            {message && (
                <div className={`p-4 mb-6 rounded-2xl font-bold ${status === 'success' ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`}>
                    {message}
                </div>
            )}

            <form onSubmit={handleUpdate} className="space-y-6 max-w-lg">
                <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">{t('admin.admin_profile.email_label', 'Email')}</label>
                    <input
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        className="w-full p-4 rounded-xl bg-gray-50 border-none focus:ring-2 focus:ring-brand-primary"
                    />
                </div>
                <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">{t('admin.admin_profile.new_password', 'New Password (leave blank to keep current)')}</label>
                    <input
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        className="w-full p-4 rounded-xl bg-gray-50 border-none focus:ring-2 focus:ring-brand-primary"
                        placeholder="********"
                    />
                </div>
                <div>
                    <label className="block text-sm font-bold text-gray-700 mb-2">{t('admin.admin_profile.confirm_password', 'Confirm New Password')}</label>
                    <input
                        type="password"
                        name="confirmPassword"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        className="w-full p-4 rounded-xl bg-gray-50 border-none focus:ring-2 focus:ring-brand-primary"
                        placeholder="********"
                    />
                </div>

                <button type="submit" className="bg-brand-primary text-white px-8 py-4 rounded-xl font-black text-xs uppercase tracking-widest shadow-lg hover:scale-105 transition-all">
                    {t('admin.admin_profile.update_btn', 'Update Profile')}
                </button>
            </form>
        </div>
    );
};


export default AdminProfile;
